import '@/css/app.css'
import Alpine from 'alpinejs'
import Headroom from 'headroom.js'
import collapse from '@alpinejs/collapse'
import './cookie-consent-mode.js'
import './base/revealOnScroll.js'
import './base/parallax.js'
import gsap from 'gsap'
import { InertiaPlugin } from 'gsap/InertiaPlugin'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(InertiaPlugin)
gsap.registerPlugin(ScrollTrigger)
import Lenis from 'lenis'
const lenis = new Lenis({
    autoRaf: true,
    anchors: {
        offset: -50
    }
})

const headroom = () => {
    const headroom = new Headroom(document.querySelector('header'), {
        offset: 100,
        onTop: function () {
            document.querySelector('body').classList.add('headroom--top')
            document.querySelector('body').classList.remove('headroom--not-top')
        },

        onNotTop: function () {
            document.querySelector('body').classList.remove('headroom--top')
            document.querySelector('body').classList.add('headroom--not-top')
        }
    }).init()
}

const typeWriter = () => {}

// App main
const main = async () => {
    headroom()
    // Dit komt overeen met de twig var blockHandle
    // const blocks = []
    const components = [
        'fancybox',
        'swiper',
        'accordionComp',
        'langSwitcher',
        'googleMaps',
        'faq',
        'count',
        'plyr',
        'typewriter',
        'lottie'
    ]

    const importPromises = []

    // for (const block of blocks) {
    //     const blockElements = document.querySelectorAll(`.${block}`)

    //     if (blockElements.length === 0) {
    //         continue
    //     }

    //     const importPromise = import(`./blocks/${block}.js`).then(
    //         ({ init }) => {
    //             blockElements.forEach((block) => {
    //                 importPromises.push(init(block))
    //             })
    //         }
    //     )

    //     importPromises.push(importPromise)
    // }

    for (const comp of components) {
        const compElements = document.querySelectorAll(`.${comp}`)
        if (compElements.length === 0) {
            continue
        }

        const importPromise = import(`./components/${comp}.js`).then(
            ({ init }) => {
                compElements.forEach((comp) => {
                    importPromises.push(init(comp))
                })
            }
        )

        importPromises.push(importPromise)
    }

    importPromises.push(
        import('./base/animations.js').then(({ initAnimations }) =>
            initAnimations()
        )
    )

    importPromises.push(
        import('./base/menu.js').then(({ initMenu }) => initMenu())
    )
    return await Promise.all(importPromises)
}

main().then(() => {
    console.log('Vite <3')
    window.Alpine = Alpine

    Alpine.plugin(collapse)
    Alpine.start()

    const anchor = getAnchor()
    if (anchor) {
        const anchorElement = document.querySelector(`#${anchor}`)
        if (anchorElement) {
            setTimeout(() => {
                lenis.scrollTo(anchorElement, {
                    offset: -50
                })
                // anchorElement.scrollIntoView({ behavior: 'smooth' })
            }, 500)
        }
    }

    const uitWidget = document.querySelector('#uit')
    if (uitWidget) {
        setTimeout(() => {
            lenis.scrollTo(uitWidget, {
                offset: -50
            })
            // anchorElement.scrollIntoView({ behavior: 'smooth' })
        }, 500)
    }
})

const getAnchor = () => {
    var currentUrl = document.URL,
        urlParts = currentUrl.split('#')

    return urlParts.length > 1 ? urlParts[1] : null
}

document.addEventListener('DOMContentLoaded', () => {
    initLoopingWordsWithSelector()
})
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR')
    })
}

function initLoopingWordsWithSelector() {
    const wordList = document.querySelector('[data-looping-words-list]')
    if (!wordList) {
        return
    }

    if (wordList.dataset.loopingWordsInit === 'true') {
        return
    }
    wordList.dataset.loopingWordsInit = 'true'

    const words = Array.from(wordList.children)
    const totalWords = words.length

    if (totalWords === 0) {
        return
    }

    const visibleCount = Math.min(3, totalWords)
    const movementDuration = 0.9
    const movementEase = 'elastic.out(1, 0.99)'
    const rotationStart = 0
    const rotationDuration = movementDuration
    const rotationEaseIn = 'power2.inOut'
    const rotationEaseOut = 'power2.out'

    let currentIndex = 0
    const calculateStepHeight = () => {
        const items = wordList.children

        if (items.length > 1) {
            const first = items[0]
            const second = items[1]

            if (first && second) {
                return (
                    second.getBoundingClientRect().top -
                    first.getBoundingClientRect().top
                )
            }
        }

        const fallback = items[0] ?? null
        return fallback?.getBoundingClientRect().height ?? 0
    }

    let stepHeight = calculateStepHeight()
    let resizeFrame = null

    const toFixedPx = (value) => parseFloat(value.toFixed(2))

    const refreshStepHeight = () => {
        const rawHeight = calculateStepHeight()
        stepHeight = toFixedPx(rawHeight)
        gsap.set(wordList, { y: toFixedPx(-stepHeight * currentIndex) })
    }

    window.addEventListener(
        'resize',
        () => {
            if (resizeFrame) {
                cancelAnimationFrame(resizeFrame)
            }
            resizeFrame = requestAnimationFrame(() => {
                refreshStepHeight()
                resizeFrame = null
            })
        },
        { passive: true }
    )

    const wordMeta = new Map(
        words.map((word) => {
            const background = word.querySelector('[data-background]') ?? null
            let rotation = 0

            if (background) {
                const rawRotation = parseFloat(
                    background.dataset?.rotation ?? '0'
                )
                rotation = Number.isNaN(rawRotation) ? 0 : rawRotation

                gsap.set(background, {
                    rotation: 0,
                    transformOrigin: '50% 50%'
                })
            }

            return [word, { background, rotation }]
        })
    )

    for (let index = 0; index < visibleCount; index++) {
        const meta = wordMeta.get(words[index])
        if (!meta?.background) {
            continue
        }

        gsap.to(meta.background, {
            rotation: meta.rotation,
            duration: rotationDuration,
            ease: rotationEaseOut,
            delay: index * 0.1
        })
    }

    function moveWords() {
        const previousIndex = currentIndex
        currentIndex += 1

        const outgoingWord =
            words[previousIndex % totalWords] ?? words[previousIndex]
        const incomingWord =
            words[(previousIndex + visibleCount) % totalWords] ??
            words[previousIndex]

        const outgoingMeta = wordMeta.get(outgoingWord)
        const incomingMeta = wordMeta.get(incomingWord)

        if (outgoingMeta?.background) {
            gsap.killTweensOf(outgoingMeta.background)
        }

        if (incomingMeta?.background) {
            gsap.killTweensOf(incomingMeta.background)
        }

        if (
            incomingMeta?.background &&
            incomingMeta.background !== outgoingMeta?.background
        ) {
            gsap.set(incomingMeta.background, { rotation: 0 })
        }

        const timeline = gsap.timeline({
            onComplete: () => {
                if (currentIndex >= totalWords - visibleCount) {
                    const firstChild = wordList.children[0]
                    if (firstChild) {
                        wordList.appendChild(firstChild)
                        currentIndex -= 1
                        gsap.set(wordList, {
                            y: toFixedPx(-stepHeight * currentIndex)
                        })

                        const shiftedWord = words.shift()
                        if (shiftedWord) {
                            words.push(shiftedWord)
                        }
                    }
                }

                currentIndex = (currentIndex + totalWords) % totalWords
            }
        })

        timeline.to(
            wordList,
            {
                y: toFixedPx(-stepHeight * currentIndex),
                duration: movementDuration,
                ease: movementEase
            },
            0
        )

        if (
            outgoingMeta?.background &&
            incomingMeta?.background &&
            outgoingMeta.background === incomingMeta.background
        ) {
            timeline.to(
                outgoingMeta.background,
                {
                    rotation: 0,
                    duration: rotationDuration / 2,
                    ease: rotationEaseIn
                },
                rotationStart
            )
            timeline.to(
                outgoingMeta.background,
                {
                    rotation: incomingMeta.rotation,
                    duration: rotationDuration / 2,
                    ease: rotationEaseOut
                },
                rotationStart + rotationDuration / 2
            )
        } else {
            if (outgoingMeta?.background) {
                timeline.to(
                    outgoingMeta.background,
                    {
                        rotation: 0,
                        duration: rotationDuration,
                        ease: rotationEaseIn
                    },
                    rotationStart
                )
            }

            if (incomingMeta?.background) {
                timeline.to(
                    incomingMeta.background,
                    {
                        rotation: incomingMeta.rotation,
                        duration: rotationDuration,
                        ease: rotationEaseOut
                    },
                    rotationStart
                )
            }
        }
    }

    gsap.timeline({ repeat: -1, delay: 1 })
        .call(moveWords)
        .to({}, { duration: 2 })
}

function initMomentumBasedHover() {
    // If this device can’t hover with a fine pointer, stop here
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        return
    }

    // Configuration (tweak these for feel)
    const xyMultiplier = 5 // multiplies pointer velocity for x/y movement
    const rotationMultiplier = 5 // multiplies normalized torque for rotation speed
    const inertiaResistance = 600 // higher = stops sooner

    // Pre-build clamp functions for performance
    const clampXY = gsap.utils.clamp(-1080, 1080)
    const clampRot = gsap.utils.clamp(-60, 60)

    // Initialize each root container
    document.querySelectorAll('[data-momentum-hover-init]').forEach((root) => {
        let prevX = 0,
            prevY = 0
        let velX = 0,
            velY = 0
        let rafId = null

        // Track pointer velocity (throttled to RAF)
        root.addEventListener('mousemove', (e) => {
            if (rafId) return
            rafId = requestAnimationFrame(() => {
                velX = e.clientX - prevX
                velY = e.clientY - prevY
                prevX = e.clientX
                prevY = e.clientY
                rafId = null
            })
        })

        // Attach hover inertia to each child element
        root.querySelectorAll('[data-momentum-hover-element]').forEach((el) => {
            el.addEventListener('mouseenter', (e) => {
                const target = el.querySelector('[data-momentum-hover-target]')
                if (!target) return

                // Compute offset from center to pointer
                const { left, top, width, height } =
                    target.getBoundingClientRect()
                const centerX = left + width / 2
                const centerY = top + height / 2
                const offsetX = e.clientX - centerX
                const offsetY = e.clientY - centerY

                // Compute raw torque (px²/frame)
                const rawTorque = offsetX * velY - offsetY * velX

                // Normalize torque so rotation ∝ pointer speed (deg/sec)
                const leverDist = Math.hypot(offsetX, offsetY) || 1
                const angularForce = rawTorque / leverDist

                // Calculate and clamp velocities
                const velocityX = clampXY(velX * xyMultiplier)
                const velocityY = clampXY(velY * xyMultiplier)
                const rotationVelocity = clampRot(
                    angularForce * rotationMultiplier
                )

                // Apply GSAP inertia tween
                gsap.to(target, {
                    inertia: {
                        x: { velocity: velocityX, end: 0 },
                        y: { velocity: velocityY, end: 0 },
                        rotation: { velocity: rotationVelocity, end: 0 },
                        resistance: inertiaResistance
                    }
                })
            })
        })
    })
}

// Initialize Momentum Based Hover (Inertia)
document.addEventListener('DOMContentLoaded', () => {
    initMomentumBasedHover()
})

// Automatisch recipients invullen voor contact formulier gebaseerd op het onderwerp/ faq categorie
document.addEventListener('DOMContentLoaded', () => {
    const selectEl = document.querySelector('[data-subject-field]')
    const hiddenEl = document.querySelector('[data-recipients-field]')
    const list = Array.isArray(window.recipientsArray)
        ? window.recipientsArray
        : []

    if (!selectEl || !hiddenEl) {
        console.warn('Select of hidden veld niet gevonden.')
        return
    }

    // Maak van [{ "2379": [...] }, { "2381": [...] }, ...] -> { "2379": [...], "2381": [...], ... }
    const recipientsMap = Object.assign({}, ...list)

    function syncHidden() {
        const id = String(selectEl.value)
        const emails = Array.isArray(recipientsMap[id]) ? recipientsMap[id] : []
        console.log(emails)
        // mailto: weghalen en als CSV in hidden zetten
        hiddenEl.value = emails
            .map((e) => String(e).replace(/^mailto:/i, ''))
            .join(',')
        hiddenEl.dispatchEvent(new Event('change', { bubbles: true }))
    }

    selectEl.addEventListener('change', syncHidden)

    // init (als er al een waarde is in de select)
    if (selectEl.value) syncHidden()
})

function initFaceFollowCursor() {
    const faceSections = document.querySelectorAll('[data-face]')
    if (!faceSections.length) return

    faceSections.forEach((section) => {
        const baseIntensity =
            parseFloat(section.getAttribute('data-face')) || 30

        const targets = Array.from(
            section.querySelectorAll('[data-face-target]')
        ).map((el) => {
            const factor = parseFloat(el.getAttribute('data-face-target')) || 1
            return {
                el,
                factor,
                intensity: baseIntensity * factor,
                setX: gsap.quickTo(el, 'xPercent', {
                    duration: 0.3,
                    ease: 'power2'
                }),
                setY: gsap.quickTo(el, 'yPercent', {
                    duration: 0.3,
                    ease: 'power2'
                })
            }
        })

        let isTracking = false
        let isRAFRunning = false
        let lastMouse = { x: 0, y: 0 }

        const update = () => {
            const mx = lastMouse.x
            const my = lastMouse.y

            targets.forEach((target) => {
                const r = target.el.getBoundingClientRect()
                const cx = r.left + r.width / 2
                const cy = r.top + r.height / 2
                const rx = r.width / 2
                const ry = r.height / 2

                let nx = (mx - cx) / rx
                let ny = (my - cy) / ry

                const mag = Math.hypot(nx, ny)
                if (mag > 1) {
                    nx /= mag
                    ny /= mag
                }

                const mappedX = nx * target.intensity
                const mappedY = ny * target.intensity

                target.setX(mappedX)
                target.setY(mappedY)
            })

            isRAFRunning = false
        }

        const onMouseMove = (e) => {
            lastMouse.x = e.clientX
            lastMouse.y = e.clientY
            if (!isRAFRunning) {
                requestAnimationFrame(update)
                isRAFRunning = true
            }
        }

        const startTracking = () => {
            if (!isTracking) {
                window.addEventListener('mousemove', onMouseMove)
                isTracking = true
            }
        }

        const stopTracking = () => {
            if (isTracking) {
                window.removeEventListener('mousemove', onMouseMove)
                isTracking = false
            }
        }

        ScrollTrigger.create({
            trigger: section,
            start: 'top bottom',
            end: 'bottom top',
            onEnter: startTracking,
            onEnterBack: startTracking,
            onLeave: stopTracking,
            onLeaveBack: stopTracking
        })
    })
}

// Initialize Face Follow Cursor (Mascot)
document.addEventListener('DOMContentLoaded', () => {
    initFaceFollowCursor()
})
